import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Levererat och säkrat: Controlas produktnyheter hittills under 2026",
  header:
    "Levererat och säkrat: Det här har vi lagt till, fixat och förbättrat hittills under 2026",
  date: "2026-09-30",
  description:
    "Upptäck nyheterna i Controla: enklare onboarding, tydligare uppgifter, backup med 50 GB lagring, bättre överblick för administratörer och en uppdaterad webbplats.",
  category: "produkt",
  draft: false,
  authorKey: "thea_naree",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
